import React from "react";
import { RouteItem } from "../Interface/interface";

export const RouterList: RouteItem[] = [
  {
    role: 1,
    path: "/",
    element: React.lazy(() => import("../screens/Auth/Login/Login")),
  },
  {
    role: 2,
    path: "login",
    element: React.lazy(() => import("../screens/Auth/Login/Login")),
  },
  {
    role: 3,
    path: "/forget-password",
    element: React.lazy(
      () => import("../screens/Auth/ForgetPassword/ForgetPassword")
    ),
  },
  {
    role: 4,
    path: "/reset-password",
    element: React.lazy(
      () => import("../screens/Auth/ResetPassword/ResetPassword")
    ),
  },
];
export const AuthRouter: any[] = [
  {
    subrole: 1,
    subpath: "/estimates",
    subelement: React.lazy(() => import("../screens/EstimatePage/Estimate")),
  },
  {
    subrole: 1,
    subpath: "/edit-admin-profile",
    subelement: React.lazy(
      () => import("../screens/Auth/EditAdminProfile/EditAdminProfile")
    ),
  },
  {
    subrole: 1,
    subpath: "/user-profile",
    subelement: React.lazy(() => import("../screens/UserProfile/UserProfile")),
  },
  {
    subrole: 1,
    subpath: "/configuration",
    subelement: React.lazy(() => import("../screens/AdminConfig/index")),
  },

  {
    subpath: "/estimates/create",
    subelement: React.lazy(() => import("../screens/Create/index")),
  },
  {
    subpath: "/estimates/update",
    subelement: React.lazy(() => import("../screens/Create/index")),
  },
  {
    subpath: "/estimate/view",
    subelement: React.lazy(() => import("../screens/Create/index")),
  },
  {
    subrole: 1,
    subpath: "/partners",
    subelement: React.lazy(() => import("../screens/Partners/Partner")),
  },
  {
    subrole: 1,
    subpath: "/ManageRoles",
    subelement: React.lazy(() => import("../screens/ManageRoles/ManageRoles")),
  },
  {
    subrole: 1,
    subpath: "/partner-detail/:id",
    subelement: React.lazy(() => import("../screens/Partners/PartnerDetailPage")),
  },
  {
    subrole: 1,
    subpath: "/edit-pdf/:id",
    subelement: React.lazy(() => import("../screens/EditPDF/EditPDF")),
  },
  {
    // subrole: 1,
    subpath: "/manageCurrencies",
    subelement: React.lazy(() => import("../screens/ManageCurrency/ManageCurrency")),
  },
  {
    subrole: 1,
    subpath: "/ManageProducts",
    subelement: React.lazy(() => import("../screens/MangeProducts/index")),
  },
  {
    subrole: 1,
    subpath: "/Federals",
    subelement: React.lazy(() => import("../screens/Federal/Federal")),
  },
   {
    subrole: 1,
    subpath: "/federalConfig",
    subelement: React.lazy(() => import("../screens/AdminConfig/index")),
  },
];
